// assets
import { BookOutlined,UserOutlined } from '@ant-design/icons';

// icons
const icons = {
  BookOutlined,
  UserOutlined
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const support = {
  id: 'cadastros',
  title: 'Cadastros e Configurações',
  type: 'group',
  children: [
    {
      id: 'normativas',
      title: 'Normativas',
      type: 'item',
      url: '/normativas',
      icon: icons.BookOutlined,
      breadcrumbs: false
    },
    {
      id: 'usuarios',
      title: 'Usuários',
      type: 'item',
      url: '/usuarios',
      icon: icons.UserOutlined,
      breadcrumbs: false
    }
  ]
};

export default support;
